import BreadCrumb from '../../../../components/Breadcrumb/breadCrumb'
import steps from '../../../../components/steps/steps'
import backBtn from '../../../../components/backButton/backButton'
import tabs from '../../../../components/tabs/tabs'
import noData from '../../../../components/noData/noData'
import titleLine from '../../../../components/titleLine/titleLine'
import search from '../../../../components/searchBox/searchBox'
import * as requiredUrls from '../../../../utils/appointment.url'
import apponitmentNotice from "@/components/dialog/apponitmentNotice";
import {
  interArea,
  interHall
} from '@/utils/appointment.url.js'
import {
  Loading,
  Dialog,
} from 'element-ui'
export default {
    data: function () {
        return {
            tabsList: [{
                value: '单位',
                id: 1
            },{
                value: '服务类型',
                id: 2
            }],
            value: '',
            dataList: [],// 父级业务列表
            childrenList: [],// 子业务列表
            areaSeq: this.$route.query.areaSeq,
            dialogTableVisible: false,// 控制事项列表弹窗
            childrShow: false,// 子业务弹窗控制
            matterList: '',// 事项列表
            itemCount:'',
            bsSeq: '',
            bsName: '',
            itemCode:this.$route.query.itemCode,
            batOpenStatus: '', // 暂存，弹框用（按事项预约模式）
            ifMulPlaces: '', // 暂存，弹框用（按事项预约模式）
            maxOfHandle: '', // 暂存，弹框用（按事项预约模式）
            currTerm: {}
        }
    },
    components: {
        BreadCrumb,
        steps,
        tabs,
        search,
        backBtn,
        noData,
        titleLine,
        apponitmentNotice
      },
    methods: {
        // 搜索框
        getInputValue (value) {
            console.log(value);  
            this.getData(value);
        },
        clickContentBlock (t, i) {
            console.log(t);
          this.itemCount = t.itemCount;
          this.clickItem = t;
          this.currTerm = t;
          this.clickIndex = i;
            // 如果存在外链，直接跳转
            if (t.moShowUrl) {
                window.open(t.moShowUrl);
            } else {
                // V2.1.3 需求：按事项预约模式调整
                if (t.showItem == 0) {
                  this.clickItemList(t, i);
                  return;
                }
                if(t.reserveDesc && t.reserveDesc !== "") {
                  console.log(this.currTerm, "this.currTerm")
                  this.$refs.remider.handleOpenDialog(t.reserveDesc);
                }else {
                  this.getChildrenData(t);
                }
                // this.getChildrenData(t);   
            }            
        },
        clickRemider() {
          if(this.itemCount == 0) {
            let item = this.remindItem;
            this.$router.push({
              path: '/serviceHall',
              query: {
                bsName: this.bsName,
                bsSeq: this.bsSeq,
                areaSeq: this.$route.query.areaSeq,
                matterSeq: item.seq,
                matterName: item.name,
                hallName: this.$route.query.hallName,
                stepsType:　2,
                batOpenStatus: this.batOpenStatus, // 批量预约服务开关
                ifMulPlaces: this.ifMulPlaces, // 批量件是否占用多个预约名额
                maxOfHandle: this.maxOfHandle, // 批量件最大办理数量
              }
            })
          }else {
            this.getChildrenData(this.clickItem);
          }
        },
        clickItemList (t, i) {
            this.dialogTableVisible = true;
            this.bsSeq = t.seq;
            this.bsName = t.name;
            this.getMatterList(t);
        },
        // 点击事项列表预约
        goServiceHallOne (item) {
          this.remindItem = item;
          let i = this.clickItem;
          if(i.reserveDesc && i.reserveDesc !== "") {
            this.$refs.remider.handleOpenDialog(i.reserveDesc);
          }else {
            this.$router.push({
              path: '/serviceHall',
              query: {
                bsName: this.bsName,
                bsSeq: this.bsSeq,
                areaSeq: this.$route.query.areaSeq,
                matterSeq: item.seq,
                matterName: item.name,
                hallName: this.$route.query.hallName,
                stepsType:　2,
                batOpenStatus: this.batOpenStatus, // 批量预约服务开关
                ifMulPlaces: this.ifMulPlaces, // 批量件是否占用多个预约名额
                maxOfHandle: this.maxOfHandle, // 批量件最大办理数量
              }
            })
          }
            
        },
        // 获取大厅列表数据
        getData (value) {
            console.log('hah',this.areaSeq)
            requiredUrls.interBs({
                keyword: value,// 搜索关键字
//              areaSeq: this.areaSeq,
                uType: sessionStorage.getItem('uType'),
                unitSeq: this.$route.query.unitSeq,// 单位主键
                serTypeSeq: this.$route.query.serTypeSeq,//服务类型主键
                parentSeq: '',// 查询子业务时传的主键 
                itemCode: this.itemCode,//事项编码
                reserveSrc: 0, // 预约渠道 0、PC端自主预约；
              },
              'post'
        ).then(res => {
//            loading.close();  
              if (res.status == '200') {
                console.log(res.data)
                this.dataList = res.data.dataList;
                if(this.itemCode && this.dataList.length == 0){
                  this.$router.push({
                    path:'/index',
                    query:{
                      areaSeq:this.$route.query.areaSeq
                    }
                  });
                }else if(this.itemCode && this.dataList.length == 1){
                  this.bsName = this.dataList[0].name;
                  this.bsSeq =  this.dataList[0].seq;
                  this.getApprItem();
                }
              } else {
                this.$message.error(res.desc)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        // 更具事项编码获取事项名称
        getApprItem(){
          requiredUrls.getApprItem({
            itemCode: this.itemCode
          },'get').then(res => {
            if(res.status == '200'){
              let item = {
                seq:this.itemCode,
                name: res.data.approveName
              };
              console.log('item==',item)
              this.goServiceHallOne(item);
            }
          }).catch(err => {
            console.log(err);
          });
        },
        // 获取子业务数据
        getChildrenData (t) {
            let _this = this;
            console.log('hah',this.areaSeq)
            requiredUrls.interBs({
                keyword: '',// 搜索关键字
//              areaSeq: this.areaSeq,
                uType: sessionStorage.getItem('uType'),
                unitSeq: this.$route.query.unitSeq,// 单位主键
                serTypeSeq: this.$route.query.serTypeSeq,//服务类型主键
                parentSeq: t.seq,// 查询子业务时传的主键 
                reserveSrc: 0, // 预约渠道 0、PC端自主预约；
              },
              'post'
            ).then(res => {
              if (res.status == '200') {
                console.log(res.data)
                if (res.data.dataList.length > 0) {
                    _this.childrenList = res.data.dataList;
                    this.childrShow = true;
                } else {
                    _this.$router.push({
                        path: '/serviceHall',
                        query: {
                          areaSeq: _this.$route.query.areaSeq,
                          bsSeq: t.seq,// 业务主键
                          bsName: t.name,// 业务名称
                          hallName: _this.$route.query.hallName,// 服务大厅
                          stepsType:　2,
                          batOpenStatus: t.batOpenStatus, // 批量预约服务开关
                          ifMulPlaces: t.ifMulPlaces, // 批量件是否占用多个预约名额
                          maxOfHandle: t.maxOfHandle, // 批量件最大办理数量
                        }
                      })    
                }                
              } else {
                this.$message.error(res.desc)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        // 获取业务绑定事项列表数据
        getMatterList (item) {
            // 记录当前点击项业务号和业务名称
            this.bsName = item.name;
            this.bsSeq = item.seq;
            this.itemCount = item.itemCount;
            // 记录事项批量办理配置
            this.batOpenStatus = item.batOpenStatus; // 批量预约服务开关
            this.ifMulPlaces = item.ifMulPlaces; // 批量件是否占用多个预约名额
            this.maxOfHandle = item.maxOfHandle; // 批量件最大办理数量

            this.dialogTableVisible = true;
            requiredUrls.interBsi({
                bsSeq: item.seq
            },
              'get'
        ).then(res => {
              console.log(res);
              if (res.status == '200') {
                this.matterList = res.data;
              } else {
                this.$message.error(res.desc)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
    },
    mounted () {
       this.getData();
    },  
}
